export default __webpack_public_path__ + "571c3e0454625e2368cf2be0549caa01.png";